/**
 * CSK Agentic Boundary Kernel Demo — application shell.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */
import { createMonographRouteApp } from "../MonographRouteApp.js";
import { NAVIGATION } from "./data/nav.js";
import { panelTokens } from "@csk/demo-ui";
export const App = createMonographRouteApp({
  navigation: NAVIGATION,
  theme: panelTokens,
  surfaceTokenPrefix: "abk",
  slug: "agentic-boundary-kernel",
  title: "Agentic Boundary Kernel",
  eyebrow: "INTERACTIVE DEMO · RD-27",
  tagline:
    "Every agent boundary crossing is a CSK seam crossing. A crossing not in possession of its required witness tuple cannot be expressed in a way that type-checks.",
  companionPath: "research/settled/RD-27-AGENTIC-BOUNDARY-KERNEL.md",
  mainRegionId: "abk-main",
  backgroundColor: "#08142a",
});
